<template>
  <div class="order-group-detail">
    <div class="total-info">
      <div class="box1">
        <p>订单编号：{{ detail.order_number }}</p>
        <p>昵称：{{ detail.nickname }} / {{ detail.mobile }}</p>
        <p>下单时间：{{ detail.created_at | tsFormatLong }}</p>
        <p>商品类型：{{ detail.shop_type_name }}</p>
      </div>
      <div class="box2">
        <div class="time-line">
          <div class="item" v-for="(value, name, index) in timelineData" :key="index">
            <p class="label">{{ index + 1 }}.{{ value.title }}</p>
            <i class="circle" :class="{ active: value.active }"></i>
            <p class="time">{{ value.time }}</p>
          </div>
        </div>
        <div class="desc">
          <Icon type="ios-information-circle-outline" size="35" color="#f49015" />
          <div class="text">
            <p class="abstruct">{{ timelineDesc.abstruct }}</p>
            <p class="info">{{ timelineDesc.info }}</p>
            <div class="btn-wrap" v-if="detail.ship_status == 1">
              <Button type="text" @click="onDelivery">发货</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="detail.shop_type == 12" class="delivery-info">
      <div class="receiver-info">
        <p class="label">收货人信息：</p>
        <p class="info">收货人：{{ detail.address.user_name }}</p>
        <p class="info">手机号：{{ detail.address.mobile }}</p>
        <p
          class="info"
        >收货地址：{{detail.address.province_name+detail.address.city_name+detail.address.district_name+detail.address.address}}</p>
      </div>
      <div class="logistics-info">
        <p class="label">配送信息：</p>
        <p class="info">配送方式：普通快递</p>
        <p class="info">配送时间：{{ detail.ship_time_ts }}</p>
        <p class="info">快递公司：{{ detail.logistics.logistics_name }}</p>
        <p class="info">
          <span style="margin-right:10px;">快递单号：{{ detail.logistics.logistics_no }}</span>
          <input
            ref="input"
            type="text"
            :value="detail.logistics.logistics_no"
            style="width:1px;border:none;color:white;outline:none;"
          />
          <Button v-if="!!detail.logistics.logistics_no" type="text" @click="copy">复制</Button>
        </p>
      </div>
    </div>
    <div class="price-info">
      <p class="label title">订单信息</p>
      <Table :columns="tableColumns" :data="tableDatas" border></Table>
      <div class="more">
        <p>商品总价：{{detail.total_price}}积分</p>
      </div>
    </div>
    <delivery-dlg v-model="deliveryDlgShow" :data="detail" @on-ok="requestDetail"></delivery-dlg>
  </div>
</template>

<script>
import { ShopType } from "@/utils/enums";
import DeliveryDlg from "../../finance/components/DeliveryDlg";
export default {
  name: "IntegralExchangeDetail",
  components: {
    DeliveryDlg
  },
  data() {
    return {
      id: this.$route.query.id,
      detail: {},
      timelineStep: 1,
      timelineData: {
        1: {
          title: "买家下单",
          active: false,
          time: "",
          abstruct: "买家已下单，等待付款",
          info: "买家已下单，等待付款"
        },
        2: {
          title: "买家付款",
          active: false,
          time: "",
          abstruct: "买家已付款，等待商家发货",
          info: "买家已付款，请尽快发货"
        },
        3: {
          title: "卖家发货",
          active: false,
          time: "",
          abstruct: "商家已发货，等待交易成功",
          info: "等待买家确认收货"
        },
        4: {
          title: "交易成功",
          active: false,
          time: "",
          abstruct: "交易成功"
        }
      },
      tableColumns: [
        { title: "商品", key: "shop_name", align: "left", minWidth: 250 },
        {
          title: "商品类型",
          key: "shop_type_name",
          align: "center",
          minWidth: 100
        },
        {
          title: "单价（积分）",
          key: "order_price",
          align: "center",
          minWidth: 100
        },
        {
          title: "数量",
          key: "product_number",
          align: "center",
          minWidth: 100
        },
        {
          title: "小计（积分）",
          key: "total_price",
          align: "center",
          minWidth: 100
        }
      ],
      tableDatas: [],
      changePriceShow: false,
      deliveryDlgShow: false
    };
  },
  computed: {
    timelineDesc() {
      let ret = {};
      if (this.timelineData[this.timelineStep]) {
        ret = this.timelineData[this.timelineStep];
      }
      return ret;
    }
  },
  created() {
    this.requestDetail();
  },
  methods: {
    onDelivery() {
      this.deliveryDlgShow = true;
    },
    setTimelineStep(data) {
      if (data.created_at) {
        this.timelineStep = 2;
        this.timelineData[1].time = this.$pub.timestampToTime(data.created_at);
        this.timelineData[2].time = this.$pub.timestampToTime(data.created_at);
      }
      if (data.delivery_at) {
        this.timelineStep = 3;
        this.timelineData[3].time = this.$pub.timestampToTime(data.delivery_at);
      }
      if (data.order_status == 2) {
        this.timelineStep = 4;
        this.timelineData[4].time = this.$pub.timestampToTime(data.updated_at);
      }
      if (data.shop_type != 12) {
        delete this.timelineData[3];
      }
      for (const key in this.timelineData) {
        if (key <= this.timelineStep) {
          this.timelineData[key].active = true;
        }
      }
    },
    async requestDetail() {
      let data = await this.$http.get(
        `/api/integral/exchange/detail/${this.id}`
      );
      data.order_price = data.order_price / 100;
      data.logistics = data.logistics || {};
      data.shop_type_name = ShopType.getValue(data.shop_type);
      data.total_price = data.order_price * data.product_number;
      data.ship_time_ts = data.delivery_at
        ? this.$pub.timestampToTime(data.delivery_at)
        : "";
      this.setTimelineStep(data);
      this.detail = data;
      this.tableDatas = [];
      this.tableDatas.push(data);
    },
    copy() {
      this.$refs.input.select();
      document.execCommand("Copy");
      this.$Message.success("复制成功");
    }
  }
};
</script>

<style lang="scss" scoped>
.order-group-detail {
  .total-info {
    border: 1px solid #ddd;
    display: flex;
    overflow: hidden;
    .box1 {
      padding: 20px;
      border-right: 1px solid #ddd;
      min-width: 300px;
      line-height: 22px;
      color: #888;
    }
    .box2 {
      padding: 20px;
      .time-line {
        display: flex;
        .item {
          text-align: center;
          width: 150px;
          position: relative;
          .label {
            margin-bottom: 5px;
          }
          .circle {
            display: inline-block;
            width: 15px;
            height: 15px;
            border: 1px solid #bbb;
            border-radius: 50%;
            position: relative;
            &::after {
              content: "";
              display: block;
              width: 135px;
              height: 4px;
              background-color: #ddd;
              position: absolute;
              top: 50%;
              right: 14px;
              transform: translateY(-50%);
            }
            &.active {
              background-color: #2d8cf0;
              &::after {
                background: #2d8cf0;
              }
            }
          }
          &:first-child {
            i::after {
              display: none;
            }
          }
          .time {
            color: #888;
            white-space: nowrap;
          }
        }
      }
      .desc {
        margin-top: 20px;
        display: flex;
        .text {
          margin-left: 10px;
          .abstruct {
            font-size: 18px;
            font-weight: 500;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
  .delivery-info {
    border: 1px solid #c5c5c5;
    margin-top: 20px;
    display: flex;
    .label {
      font-size: 18px;
      font-weight: 500;
    }
    .info {
      line-height: 22px;
    }
    .receiver-info {
      padding: 20px;
      min-width: 300px;
      border-right: 1px solid #c5c5c5;
    }
    .logistics-info {
      padding: 20px;
    }
  }
  .price-info {
    margin-top: 20px;
    .label {
      font-size: 16px;
      font-weight: 500;
    }
    .more {
      float: right;
      margin-top: 10px;
      line-height: 22px;
      text-align: right;
    }
  }
}
input::selection {
  background-color: white;
  color: white;
}
</style>